import AbsComponent from '../../common/components/AbsComponent';
import Utils from '../../common/Utils';

/**
 * UserState class
 * @category mainApp
 */
class FullcoverLayer extends AbsComponent{
	constructor(_store={}, _el=''){
		super(_store, _el);
		this.render();
	}

	render() {

		if( $(this.el).length === 0){
			return false;
		}

		if(window._device === 'ingame'){
			return false;
		}

		const CookieName = $(this.el)[0].getAttribute('data-cookie');

		let userAgent = window._device;
		let cookieShow = Utils.getCookie(CookieName) !== 'hide';
		let rwdShow = $(this.el).hasClass('is-rwdShow') && (userAgent !== ('ingame' || 'launcher'));
		let launcherShow = $(this.el).hasClass('is-launcherShow')  && (userAgent === 'launcher');

		// console.log( (cookieShow && rwdShow) || (cookieShow && launcherShow) );

		if((cookieShow && rwdShow) || (cookieShow && launcherShow)){

			$(this.el).show();
			$('body').addClass('prevent-scroll');

			$(this.el + ' .btn-close').on('click', (e)=>{
				Utils.setCookie( CookieName, 'hide', 365);
				$(this.el).hide();
				$('body').removeClass('prevent-scroll');
				// TweenMax.to(this.el, 0.3, {css:{scale:0.7, autoAlpha: 0}, ease: Expo.easeOut} );
			});
			$(this.el + ' .home-link').on('click', (e)=>{
				$(this.el).hide();
				$('body').removeClass('prevent-scroll');
				// TweenMax.to(this.el, 0.3, {css:{scale:0.7, autoAlpha: 0}, ease: Expo.easeOut} );
			});
		}
	}
}

export default FullcoverLayer;